import { User } from './types';

interface NewUser {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
}

// Email sending configuration
const SMTP_CONFIG = {
  host: import.meta.env.VITE_SMTP_HOST,
  port: Number(import.meta.env.VITE_SMTP_PORT),
  secure: import.meta.env.VITE_SMTP_SECURE === 'true',
  auth: {
    user: import.meta.env.VITE_SMTP_USER,
    pass: import.meta.env.VITE_SMTP_PASSWORD
  }
};

// Send email using Supabase Edge Function
const sendEmail = async (to: string, subject: string, html: string) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({
        to,
        subject,
        html,
        from: import.meta.env.VITE_SMTP_FROM
      })
    });

    if (!response.ok) {
      throw new Error(`Email sending failed: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};

export const sendWelcomeEmail = async (user: User, loginLink: string) => {
  console.log('Sending welcome email to:', user.email);
  
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h1 style="color: #4F46E5;">Bienvenue sur PimpMyJob ! 🎉</h1>
      
      <p style="font-size: 16px; line-height: 1.5;">
        Bonjour ${user.name || 'nouvel utilisateur'},
      </p>

      <p style="font-size: 16px; line-height: 1.5;">
        Nous sommes ravis de vous accueillir sur PimpMyJob, votre nouvel outil de génération d'offres d'emploi intelligentes.
      </p>

      <div style="background-color: #F3F4F6; padding: 20px; border-radius: 8px; margin: 20px 0;">
        <h2 style="color: #374151; margin-top: 0;">Pour commencer :</h2>
        <p style="margin-bottom: 15px;">Cliquez sur le lien ci-dessous pour accéder à votre compte :</p>
        <a href="${loginLink}" 
           style="display: inline-block; background-color: #4F46E5; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px;">
          Accéder à mon compte
        </a>
      </div>

      <div style="margin: 20px 0;">
        <h3 style="color: #374151;">Vos identifiants :</h3>
        <ul style="list-style-type: none; padding-left: 0;">
          <li>Email : ${user.email}</li>
          <li>Mot de passe : Celui que vous avez défini lors de l'inscription</li>
        </ul>
      </div>

      <div style="background-color: #EEF2FF; padding: 15px; border-radius: 8px; margin: 20px 0;">
        <p style="margin: 0; color: #4F46E5;">
          Votre compte est actuellement en mode ${user.role === 'trial' ? 'essai' : 'premium'}.
          ${user.role === 'trial' ? `Vous disposez de ${user.remainingCredits} crédits pour tester notre service.` : ''}
        </p>
      </div>

      <p style="color: #6B7280; font-size: 14px; margin-top: 30px;">
        Si vous avez des questions, n'hésitez pas à contacter notre équipe support.
      </p>

      <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #E5E7EB;">
        <p style="color: #9CA3AF; font-size: 14px; margin: 0;">
          Cordialement,<br>
          L'équipe PimpMyJob
        </p>
      </div>
    </div>
  `;

  try {
    const result = await sendEmail(
      user.email,
      'Bienvenue sur PimpMyJob !',
      html
    );
    console.log('Welcome email sent successfully:', result);
    return result;
  } catch (error) {
    console.error('Failed to send welcome email:', error);
    throw error;
  }
};

export const sendNewUserNotification = async (user: NewUser) => {
  console.log('Sending new user notification for:', user.email);
  
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h1 style="color: #4F46E5;">Nouvelle inscription sur PimpMyJob</h1>
      
      <div style="background-color: #F3F4F6; padding: 20px; border-radius: 8px; margin: 20px 0;">
        <h2 style="color: #374151; margin-top: 0;">Détails de l'inscription :</h2>
        <ul style="list-style-type: none; padding-left: 0;">
          <li><strong>Prénom :</strong> ${user.firstName}</li>
          <li><strong>Nom :</strong> ${user.lastName}</li>
          <li><strong>Email :</strong> ${user.email}</li>
          <li><strong>Société :</strong> ${user.company}</li>
          <li><strong>Date d'inscription :</strong> ${new Date().toLocaleString('fr-FR')}</li>
        </ul>
      </div>
    </div>
  `;

  try {
    const result = await sendEmail(
      'gerald@recruteurs.io',
      'Nouvelle inscription sur PimpMyJob',
      html
    );
    console.log('New user notification sent successfully:', result);
    return result;
  } catch (error) {
    console.error('Failed to send new user notification:', error);
    throw error;
  }
};

export { sendEmail }